// src/util/analytics.js
import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-3BWHP4ZKYH'; // replace this with your real ID

export const initGA = () => {
    ReactGA.initialize(MEASUREMENT_ID);
};

export const logPageView = (path) => {
    ReactGA.send({ hitType: 'pageview', page: path });
};
